import { PropsWithChildren, useState } from 'react'

import { useBoolean } from 'ahooks'
import { Button, ColorPicker, Divider } from 'antd'
import { createStyles } from 'antd-style'

import { FontBackgroundColorPickerProps } from './interface'

const presetColors = [
  'rgb(255, 255, 0)',
  'rgb(0, 255, 0)',
  'rgb(0, 255, 255)',
  'rgb(255, 0, 255)',
  'rgb(0, 0, 255)',
  'rgb(255, 0, 0)',
  'rgb(0, 0, 128)',
  'rgb(0, 128, 128)',
  'rgb(0, 128, 0)',
  'rgb(128, 0, 128)',
  'rgb(128, 0, 0)',
  'rgb(128, 128, 0)',
  'rgb(128, 128, 128)',
  'rgb(192, 192, 192)',
  'rgb(0, 0, 0)'
]

const presets = [
  {
    label: '预设颜色',
    colors: presetColors
  }
]

const useStyles = createStyles(({ token }) => ({
  clearBtn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'start',
    lineHeight: 1,
    width: '100%'
  },
  clearIcon: {
    position: 'relative',
    display: 'inline-block',
    width: 18,
    height: 18,
    borderRadius: token.borderRadiusSM,
    border: `${token.lineWidth}px ${token.lineType} ${token.colorBorder}`,
    cursor: 'pointer',
    overflow: 'hidden',

    [`&::after`]: {
      content: '""',
      position: 'absolute',
      insetInlineEnd: 1,
      top: 0,
      display: 'block',
      width: 40,
      height: 2,
      transformOrigin: 'right',
      transform: 'rotate(-45deg)',
      backgroundColor: token.red
    }
  },
  panel: {
    width: 360
  }
}))

export const FontBackgroundColorPicker = ({
  /* -------------------------------------------------------------------------- */
  /*                       FontBackgroundColorPicker Props                      */
  /* -------------------------------------------------------------------------- */
  children,
  value,
  onChange,

  /* -------------------------------------------------------------------------- */
  /*                              ColorPicker Props                             */
  /* -------------------------------------------------------------------------- */
  ...colorPickerProps
}: PropsWithChildren<FontBackgroundColorPickerProps>) => {
  const [open, openActions] = useBoolean(false)
  const [pickerValue, setPickerValue] = useState(value)

  const handleOpenChange = (open: boolean) => {
    openActions.set(open)
    if (!open) {
      onChange(pickerValue)
    }
  }
  const { styles } = useStyles()

  return (
    <ColorPicker
      {...colorPickerProps}
      open={open}
      presets={presets}
      value={pickerValue}
      panelRender={(_, { components: { Picker, Presets } }) => (
        <div className={styles.panel}>
          <Button
            className={styles.clearBtn}
            icon={<span className={styles.clearIcon} />}
            type='text'
            onClick={() => setPickerValue(undefined)}
          >
            无填充色
          </Button>
          <Divider orientation='horizontal' style={{ margin: '8px 0' }} />
          <Presets />
          <Picker />
        </div>
      )}
      onChange={(_, cssColor) => setPickerValue(cssColor)}
      // onChangeComplete={openActions.setFalse}
      onOpenChange={handleOpenChange}
    >
      {children}
    </ColorPicker>
  )
}
